import Script from 'next/script'
import { useEffect, useState } from 'react'
import { Persistor } from 'redux-persist/es/types'

import Toasts from '@/components/Toasts/Toasts'
import { useAds } from '@/contexts/ads'

import Footer from './Footer/Footer'
import Navbar from './Navbar/Navbar'

type Props = {
  children: React.ReactNode
  persistor: Persistor
}

const Layout = ({ children, persistor }: Props) => {
  const { loadAds } = useAds()
  const [initAds, setInitAds] = useState(false)

  useEffect(() => {
    if (!initAds && loadAds === true) {
      console.log('[MV] Loading MV bundle')
      setInitAds(true)
    }
  }, [loadAds])

  return (
    <>
      <header>
        <Navbar persistor={persistor} />
        {loadAds === true ? (
          <Script
            async
            data-cfasync='false'
            data-noptimize='1'
            src='//scripts.mediavine.com/tags/edhrec.js'
            type='text/javascript'
          />
        ) : (
          <div
            data-blocklist-adhesion-desktop='1'
            data-blocklist-adhesion-mobile='1'
            data-blocklist-adhesion-tablet='1'
            data-blocklist-auto-insert-sticky='1'
            data-blocklist-chicory='1'
            data-blocklist-content-desktop='1'
            data-blocklist-content-mobile='1'
            data-blocklist-in-image='1'
            data-blocklist-interstitial-desktop='1'
            data-blocklist-interstitial-mobile='1'
            data-blocklist-leaderboard='1'
            data-blocklist-recipe='1'
            data-blocklist-sidebar-atf='1'
            data-blocklist-sidebar-btf='1'
            data-blocklist-universal-player-desktop='1'
            data-blocklist-universal-player-mobile='1'
            data-blocklist-zergnet='1'
            id='mediavine-settings'
          />
        )}
      </header>
      {children}
      <Toasts />
      <Footer />
    </>
  )
}

export default Layout
